import React from 'react';
import {Link, useLocation} from "react-router-dom";
import {Sidebar, Menu, MenuItem, SubMenu} from "react-pro-sidebar";
import SidebarHeader from "./SidebarHeader";
import {isActiveLink, isActiveParentChild } from "../../../utils/linkActiveChecker";

import mobileMenuData from "../../../data/mobileMenuData";
import mobileMenuDataLahalle from "../../../data/mobileMenuDataLahalle";
import ContactModal from "../../ContactModal";
import {HashLink} from "react-router-hash-link";

const Index = ({
                 show,
                 onClose,
                 logo,
                 lien,
                 page
}) => {
  const router = useLocation();

  const menuData = lien === "/lahalle" ? mobileMenuDataLahalle : mobileMenuData;

  return (
    <div
      className={`offcanvas offcanvas-start mobile_menu-contnet ${show ? "show" : ""}`}
      tabIndex="-1"
      id="offcanvasMenu"
      data-bs-scroll="true"
    >
      <SidebarHeader onClose={onClose} logo={logo} lien={lien} />
      {/* End pro-header */}

      <Sidebar>
        <Menu>
          {menuData.map((category) => (
                  category.items && category.items.length > 0 ? (
                          <SubMenu
                                  key={category.id ? `mcategory-${category.id}` : `mcategory-${category.label}`}
                                  label={category.label}
                                  className={
                                    isActiveParentChild(category.items, router.pathname)
                                            ? "menu-active"
                                            : ""
                                  }
                          >
                            {category.items.map((menuItem, i) => (
                                    <MenuItem
                                            key={menuItem.id ? `menuItem-${menuItem.id}` : `menuItem-${category.id}-${i}`}
                                            className={
                                              isActiveLink(menuItem.routePath, router.pathname)
                                                      ? "menu-active-link"
                                                      : ""
                                            }
                                            component={<Link to={menuItem.routePath} />}
                                            onClick={onClose}
                                    >
                                      {menuItem.name}
                                    </MenuItem>
                            ))}
                          </SubMenu>
                  ) : (
                      <>

                            <MenuItem
                                    key={category.id ? `categoryM-${category.id}` : `categoryM-${category.label}`}
                                    className={
                                      isActiveLink(category.routePath, router.pathname)
                                              ? "menu-active-link"
                                              : ""
                                    }
                                    component={
                                      category.reserved || category.infos || category.faq
                                          ? null
                                          : category.routePath.startsWith("#")
                                              ? <HashLink smooth to={category.routePath} />
                                              : <Link to={category.routePath} />
                                    }
                                    onClick={onClose}
                            >
                              {category.reserved ? (
                                  <ContactModal textButton={category.label}
                                                showText={false}
                                                small="small"
                                                linkPageContact={false}
                                                iframe={true}
                                                couleur={false}
                                                designBtn={false}
                                                iconMenu={category.icon}
                                                page={page}
                                  />
                              ) : category.infos ? (
                                  <ContactModal textButton={category.label}
                                                showText={false}
                                                small="small"
                                                linkPageContact={false}
                                                iframe={false}
                                                designBtn={false}
                                                iconMenu={category.icon}
                                                page={page}
                                  />
                              ) :category.faq ? (
                                  <ContactModal textButton={category.label}
                                                showText={false}
                                                small="small"
                                                linkPageContact={false}
                                                iframe={false}
                                                designBtn={false}
                                                iconMenu={category.icon}
                                                page={page}
                                                faq={true}
                                  />
                              ) : (
                                  <>
                                  {category.icon ? (
                                        isActiveLink(category.routePath, router.pathname)
                                            ? <><img src={category.iconActive} alt={category.label} width="20" /> {category.label}</>
                                            : <><img src={category.icon} alt={category.label} width="20" /> {category.label}</>
                                    ) : (
                                        category.label
                                    )}
                                  </>
                              )}

                            </MenuItem>

                      </>
                  )
          ))}
        </Menu>
      </Sidebar>
    </div>
  );
};

export default Index;
